import { IonCol, IonItem, IonRow } from "@ionic/react";
import { useState } from "react";
import { getCurrentTechno, jobsMap } from "../../variables/jobDictionnary";
import { ItemsTechno } from "../../variables/welcomeInterface";
import BasicPage from "../BasicPage/BasicPage";
import "../IonColor/color.css";
import "../generalCSS/stylesheet.css";
import ItemTechno from "./ItemTechno";
import "./Welcome.css";

interface ContainerProps {}

const Welcome: React.FC<ContainerProps> = () => {
  const [displayPole, setDisplayPole] = useState<number>(-1);

  const handleClick = (item: ItemsTechno, index: number) => {
    if (item.subItems === undefined && item.href)
      window.location.href = item.href;
    else if (item.subItems !== undefined && item.href) {
      if (displayPole !== index) setDisplayPole(index);
      else setDisplayPole(-1);
    } else setDisplayPole(-1);
  };

  return (
    <BasicPage mainColStyle="flex wrap">
      {jobsMap.get(getCurrentTechno())?.itemsWelcome.map((item, i) => {
        if (Array.isArray(item))
          return (
            <IonCol
              key={"arr" + i}
              className="no-margin no-padding part-array"
              size="6"
            >
              {item.map((sub, j) => {
                return (
                  <IonRow key={"sub" + j} className="part-array-item">
                    <ItemTechno
                      displayPole={displayPole}
                      handleClick={handleClick}
                      index={i}
                      item={sub}
                    />
                  </IonRow>
                );
              })}
            </IonCol>
          );
        else
          return (
            <ItemTechno
              key={i}
              displayPole={displayPole}
              handleClick={handleClick}
              index={i}
              item={item}
            />
          );
      })}
      <IonItem color="transparent" style={{ marginBottom: "6vw" }}></IonItem>
    </BasicPage>
  );
};

export default Welcome;
